import { useSelector } from 'react-redux';
import { useStore } from 'react-redux';
import { setSimplePopup } from 'state/actions';

const SimplePopupWidget = (props) => {
    const hidePopup = (e) => {
        dispatch(setSimplePopup(false))
    }

    const { dispatch } = useStore();
    const simplePopup = useSelector(store => store.simplePopup);

    if (!simplePopup) return null

    return (

        <div className={(simplePopup?.buttons ? "" : "") + "" + (simplePopup ? "" : null)}>
            <div>
                {simplePopup?.closeButton === false ? null : <button type="button" onClick={hidePopup}>X</button>}
                <div>
                    <p dangerouslySetInnerHTML={{ __html: simplePopup?.name }}></p>
                    <p dangerouslySetInnerHTML={{ __html: simplePopup?.text }}></p>
                </div>
                {
                    simplePopup?.buttons ?
                        <div>
                            {
                                simplePopup?.buttons.map((button_item, key) => {
                                    return <div key={key} className={"" + button_item?.className}>
                                        <button type="button"
                                            onClick={() => {
                                                if (simplePopup?.callback) {
                                                    simplePopup.callback(button_item?.name)
                                                }
                                                hidePopup()
                                            }}>
                                            {button_item?.title}
                                        </button>
                                    </div>
                                })
                            }
                        </div>
                        : null
                }
            </div>
        </div>
    );
};

export default SimplePopupWidget;